import { render } from "./TicketHistory.vue?vue&type=template&id=fc20c658&ts=true"
import script from "./TicketHistory.ts?vue&type=script&lang=ts"
export * from "./TicketHistory.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__